// extracted by mini-css-extract-plugin
export var completed = "OrderStatusModal-module--completed--NwxAb";
export var container = "OrderStatusModal-module--container--xY60x";
export var data = "OrderStatusModal-module--data--kGqeF";
export var head = "OrderStatusModal-module--head--Vo-gG";
export var id = "OrderStatusModal-module--id--QYYed";
export var orderTracking = "OrderStatusModal-module--orderTracking--2oWoo";
export var status = "OrderStatusModal-module--status--wA6K1";